import { render, staticRenderFns } from "./OrderDraftItemProperties.vue?vue&type=template&id=1809ef6a&"
import script from "./OrderDraftItemProperties.vue?vue&type=script&lang=js&"
export * from "./OrderDraftItemProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports